import { ParsedQuery } from 'query-string';

import { urlBuilder } from './urlBuilder';

export const addAccountUrl = (params?: ParsedQuery<string | number | boolean>, absolute: boolean = true) => {
  const productCategory = params?.product_category;
  const url = productCategory === 'direct_trading' ? urlBuilder.appAddAccount : urlBuilder.appAddGoalFlowsNew;

  return absolute ? url.absolute(params) : url(params);
};
